import { NavLink } from 'react-router-dom'
import { useSession } from '../api/session.js'
import { t } from '../i18n/index.js'

/** Simple, filled icons, thin outlines disappear on cheap phone screens. */
const ICONS = {
  today: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm1 5v5.3l3.6 2.1-.8 1.4L11 13V7h2Z" />
    </svg>
  ),
  plan: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M7 2v2H5.5A2.5 2.5 0 0 0 3 6.5v13A2.5 2.5 0 0 0 5.5 22h13a2.5 2.5 0 0 0 2.5-2.5v-13A2.5 2.5 0 0 0 18.5 4H17V2h-2v2H9V2H7Zm12 8v9.5a.5.5 0 0 1-.5.5h-13a.5.5 0 0 1-.5-.5V10h14Zm-9 2H7v3h3v-3Z" />
    </svg>
  ),
  report: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2 1.5 20.5h21L12 2Zm-1 6h2v6h-2V8Zm0 8h2v2h-2v-2Z" />
    </svg>
  ),
  stats: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4 20V10h4v10H4Zm6 0V4h4v16h-4Zm6 0v-7h4v7h-4Z" />
    </svg>
  ),
  tour: (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M12 2a7 7 0 0 0-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6.5a2.5 2.5 0 0 1 0 5Z" />
    </svg>
  ),
}

export function WorkerNav({ openToday, openUpcoming }: { openToday: number; openUpcoming: number }) {
  const { data: session } = useSession()
  return (
    <nav className="wk-nav" aria-label={t('app.tasks')}>
      <NavLink to="/app" end>
        <span style={{ position: 'relative' }}>
          {ICONS.today}
          {openToday > 0 && <span className="count">{openToday}</span>}
        </span>
        {t('nav.today')}
      </NavLink>
      <NavLink to="/app/plan">
        <span style={{ position: 'relative' }}>
          {ICONS.plan}
          {openUpcoming > 0 && <span className="count">{openUpcoming}</span>}
        </span>
        {t('nav.plan')}
      </NavLink>
      <NavLink to="/app/melden">
        {ICONS.report}
        {t('nav.report')}
      </NavLink>
      <NavLink to="/app/zahlen">
        {ICONS.stats}
        {t('nav.stats')}
      </NavLink>
      {session?.user.planningAccess && (
        <NavLink to="/app/tour">
          {ICONS.tour}
          {t('nav.tour')}
        </NavLink>
      )}
    </nav>
  )
}
